import { Share } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useToast } from "contexts/ToastContext";
import { shareFile } from "utils/share";

interface ShareButtonProps {
  url: string;
  fileName: string;
  color: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ url, fileName, color }) => {
  const { showError } = useToast();

  return (
    <Button
      size="small"
      sx={{ minWidth: 0, p: 0.5, color, flexShrink: 0 }}
      onClick={async () => {
        try {
          await shareFile({ url, fileName });
        } catch {
          showError("Failed to share file. Please try again.");
        }
      }}
    >
      <Share />
    </Button>
  );
};

export default ShareButton;
